import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Impressum from './pages/Impressum';
import DSGVO from './pages/DSGVO';
import DepartmentDetail from './pages/DepartmentDetail';
import ContactPage from './pages/ContactPage';
import AuthorsPage from './pages/AuthorsPage';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen flex flex-col bg-stone-50 dark:bg-navy-950 font-sans text-stone-800 dark:text-stone-200 transition-colors duration-300">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/autoren" element={<AuthorsPage />} />
              <Route path="/abteilung/:id" element={<DepartmentDetail />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/dsgvo" element={<DSGVO />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
